import * as Constants from '../Constant';

const initialState = {
    isPatientIdExists: false,
    message: {},
    appointmentList: [],
}

export default function appointmentReducer(state = initialState, action) {
    switch (action.type) {
        case Constants.POST_APPOINTMENT:
            return {
                ...state,
                message: action.payload,
            }
        case Constants.GET_APPOINTMENT:
            return {
                ...state,
                appointmentList: action.payload,
            }
        case Constants.DELETE_APPOINTMENT:
            return {
                ...state,
                message: action.payload,
            }
        case Constants.UPDATE_APPOINTMENT:
            return {
                ...state,
                message: action.payload,
            }
        case Constants.GET_EXITS_PATIEND_ID:
            return {
                ...state,
                isPatientIdExists: action.payload,
            }
        default:
            return state;
    }
}